import { useContext, useState } from "react";
import Section from "../../components/Common/Section"
import { NastavitveContext } from "../../context/Nastavitev/NastavitveContext";
import TabMenu from "../../components/Navigation/TabMenu";
import TabItem from "../../components/Navigation/TabItem";
import PravilnikiTab from "./PravilnikiTab";
import JavnoDetail from "./JavnoDetail";

const PravilnikiList = () => {
    const nastavitve = useContext(NastavitveContext);
    const [izobrazevanjeId, setIzobrazevanjeId] = useState<number>(-1);
    const [cardIsOpen, setCardIsOpen] = useState<boolean>(false)
    //const [activeTab, setActiveTab] = useState<Pages>(Pages.Aktualno)

    console.log("nastavitve?.ExtCode", nastavitve?.ExtCode);

    const switchTab = (index: number) => {
        setCardIsOpen(false);
        //setActiveTab(index);
    }

    function showIzobrazevanjeDetail(izobrazevanjeId: number) {
        setIzobrazevanjeId(izobrazevanjeId);
        setCardIsOpen(true);
    }


    return (
        <Section>
            <TabMenu>
                <TabItem index={0} handleClick={switchTab} active title="NZS predpisi" />
            </TabMenu>
            {!cardIsOpen ?
                <PravilnikiTab key="pravilniki" handleItemClick={showIzobrazevanjeDetail} />
                :
                <>
                    <JavnoDetail
                        izobrazevanjeId={izobrazevanjeId}
                        back={() => { setCardIsOpen(false) }}
                    />
                </>
            }


        </Section>
    );
}

export default PravilnikiList;
